import React from 'react';
import './home.css'
import Video from '../Components/Video.js'
import BrandsSlick from '../Components/BrandsSlick.js'
import Services from '../Components/Services.js'
import Team from '../Components/Team.js'
import Brands from '../Components/Brands.js'
import Works from '../Components/Works.js'
import Contact from '../Components/Contact.js'
import Ecommerce from '../Components/Ecommerce.js'
import IndexInNumbers from '../Components/IndexInNumbers.js'

function Home() {
  return (
    <div className='home'>
          <Video/>
          <BrandsSlick/>
          <Works/>
          <Services/>
          <Brands/>
          <Team/>
          <Ecommerce/>
          <IndexInNumbers/>
          <Contact/>
    </div>
  );
}
export default Home;